import { Box } from '@mui/material';
import Loading from '@/component/mui/Backdrop';
import JackpotSettingForm from '@/component/bet/JackpotSettingForm';
import { useState } from 'react';

export default function BetGameSettingJackpot() {
  const [isLoading, setIsLoading] = useState(false);

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          overflow: 'auto',
          flex: 1,
          flexDirection: 'column',
          gap: { xs: '16px', sm: '0px' },
          padding: 2,
        }}
      >
        <JackpotSettingForm />
      </Box>
      <Loading isLoading={isLoading} />
    </>
  );
}
